export const SET_NEW_PERIODS = 'SET_NEW_PERIODS'

// Unusable
export const GET_PERIODS = 'GET_PERIODS'
